<template>
  <div class="invoice-view">
    <v-card flat v-if="isLoading">
      <v-card-text>
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </v-card-text>
    </v-card>
    <div v-else>
      <v-card flat>
        <ReportViewBar v-if="Transaction" :title="`Unsettle Transaction`" />

        <v-container fluid>
          <table class="center">
            <!-- <v-divider class="mx-3"></v-divider> -->
            <tbody class="report-container">
              <v-card-text class="pt-0">
                <v-data-table dense sort-by="name" :headers="headers" :itemsPerPage="Transaction.length"
                  hide-default-footer :items="Transaction">
                  <template v-slot:item="{ item }">
                    <tr>
                      <td class="text-left">
                        <!-- <div v-if="item.Invoice">{{ item.Invoice.id }}</div> -->
                        <div v-if="item.Invoice">{{ item.Invoice.createdAt | moment("MM/DD/YYYY") }}</div>
                        <div v-else>N/A</div>
                      </td>
                      <td class="text-left">
                        <a href="#" @click="viewInvoice(item)">
                          <div v-if="item.Invoice">{{ item.Invoice.localId }}</div>
                          <div v-else>N/A</div>
                        </a>
                      </td>
                      <!-- <td class="text-left">
                        <div v-if="item.Invoice">{{ item.Invoice.localId }}</div>
                        <div v-else>N/A</div>
                      </td> -->
                      <td class="text-left">
                        <div v-if="item.Invoice && item.Invoice.Customer"
                          @click="viewCustomerProfile(item.Invoice.Customer)"><v-icon
                            color="green">mdi-account-outline</v-icon> {{ item.Invoice.Customer.name }}</div>
                        <div v-if="item.Invoice && item.Invoice.Donor" @click="viewDonorProfile(item.Invoice.Donor)">
                          <v-icon color="red">mdi-hand-coin-outline</v-icon> {{ item.Invoice.Donor.name }}</div>
                        <!-- <div v-else>N/A</div> -->
                      </td>
                      <td class="text-center text-capitalize">
                        <div v-if="item.status">{{ item.status }}</div>
                        <div v-else>N/A</div>
                      </td>
                      <td class="text-right">{{ item.amount | currency }}</td>
                    </tr>
                  </template>
                  <template v-slot:body.append="{ headers }">

                    <tr :style="{ 'background-color': '#CFD8DC' }">
                      <td :colspan="headers.length - 1" class="text-right font-weight-bold">
                        Result Total
                      </td>
                      <td class="text-right font-weight-bold">
                        {{ fullTotalAmount | currency }}
                      </td>

                    </tr>
                  </template>
                  <!-- <template v-slot:item.price="{ item }">
                    <div class="text-right">{{ item.amount | currency }}</div>
                  </template> -->
                </v-data-table>
              </v-card-text>
            </tbody>
          </table>
        </v-container>
      </v-card>
    </div>
  </div>
</template>

<script>
import ReportViewBar from "@/components/ReportViewBar";
import transactionService from "@/modules/Transaction/service.js";
import { mapGetters, mapActions } from "vuex";
import Hashids from "hashids";
const hashids = new Hashids();

export default {
  data() {
    return {
      showEmailBtn: false,
      isLoading: true,
      Transaction: null,
      fullTotalAmount: 0,
      headers: [
        {
          text: "Date",
          align: "left",
          value: "Invoice.createdAt",
          sortable: true,
        },
        {
          text: "Invoice #",
          align: "left",
          value: "Invoice.localId",
          sortable: true,
        },
        {
          text: "Name",
          align: "left",
          sortable: true,
        },
        {
          text: "Status",
          align: "center",
          sortable: true,
        },
        {
          text: "Price",
          align: "right",
          value: "price",
          sortable: true,
        },
      ],
      totalQty: 0,
    };
  },
  computed: {
    ...mapGetters("global", ["currentBusiness"]),
  },
  created() {
    this.loadData();
    if (!this.currentBusiness) this.initUser();
  },
  components: { ReportViewBar },
  methods: {
    ...mapActions("global", ["initUser", "initBusiness"]),
    viewCustomerProfile(val) {
      window.open(`/parents/${val.id}/profile`, '_blank');
      // this.$router.push({ path: `/parents/${val.id}/profile` });
    },
    viewDonorProfile(val) {
      window.open(`/donors/${val.id}/profile`, '_blank');
      // this.$router.push({ path: `/parents/${val.id}/profile` });
    },
    viewInvoice(item) {
      const invoice = item.Invoice
      if (invoice.DonorId) {
        this.donorInvoice(invoice)
      } else {
        this.openInvoice(invoice)
      }
    },
    openInvoice(invoice) {
      console.log('invoice', invoice.id)
      const hashId = hashids.encode(invoice.id);
      console.log('dueAmount', `localhost:8082/global/invoice/${hashId}/view`)
      const routeData = this.$router.resolve({
        path: `/global/invoice/${hashId}/view`,
      });
      window.open(routeData.href, "newwindow", "width=850, height=1100");
    },
    donorInvoice(invoice) {
      const hashId = hashids.encode(invoice.id);
      const routeData = this.$router.resolve({
        path: `/global/invoice/${hashId}/donorInvoice`,
      });
      window.open(routeData.href, "newwindow", "width=850, height=1100");
    },
    loadData() {
      // const id = hashids.decode(this.$route.params.id);

      return transactionService.getAll({ includeInvoice: true, onlyUnSettled: true }).then((response) => {
        console.log('response', response)
        this.$Progress.finish();
        this.Transaction = response.data;
        this.fullTotalAmount = 0
        this.Transaction.map(row => {
          this.fullTotalAmount += row.amount
        })
        this.isLoading = false;
      });
    },
  },
};
</script>

<style scoped>
@media print {
  container {
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden;
  }

  .no-print {
    display: none;
  }

  .detailBox {
    overflow: visible;
    height: 100%;
  }

  * {
    background: 0 0 !important;
    color: #000 !important;
    box-shadow: none !important;
    text-shadow: none !important;
  }
}

.paidImg {
  position: absolute;
  left: 40%;
  top: 10%;
}

.signature {
  margin-top: 100px;
}

.center {
  background-color: white;
  margin: auto;
  width: 100%;
}

/* @media print {
  .detailBox * {
    overflow: visible;
    height: 100%;
    page-break-before: always;
  }
}
.detailBox {
  overflow: auto;
  height: 600px;
} */
</style>
